import { render, staticRenderFns } from "./ad-time-money-per-device.vue?vue&type=template&id=42b07aed&scoped=true"
import script from "./ad-time-money-per-device.vue?vue&type=script&lang=js"
export * from "./ad-time-money-per-device.vue?vue&type=script&lang=js"
import style0 from "./ad-time-money-per-device.vue?vue&type=style&index=0&id=42b07aed&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b07aed",
  null
  
)

export default component.exports